import React, { useState, useEffect } from 'react';
import { env } from '../../config/env';
import '../../styles/contact-form.css';

const ContactForm = ({ isOpen, onClose }) => {
	const [formData, setFormData] = useState({
		nom: '',
		prenom: '',
		societe: '',
		telephone: '',
		email: '',
		message: '',
	});

	const [isSubmitting, setIsSubmitting] = useState(false);
	const [submitStatus, setSubmitStatus] = useState(null);
	const [clientInfo, setClientInfo] = useState({
		userAgent: '',
		ipAddress: ''
	});

	
	useEffect(() => {
		// Récupérer User Agent
		const userAgent = navigator.userAgent;
		
		// Récupérer l'IP via un service externe
		const getClientIP = async () => {
			try {
				const response = await fetch('https://api.ipify.org?format=json');
				const data = await response.json();
				return data.ip;
			} catch (error) {
				console.log('Impossible de récupérer l\'IP:', error);
				return null;
			}
		};

		const initClientInfo = async () => {
			const ip = await getClientIP();
			setClientInfo({
				userAgent: userAgent,
				ipAddress: ip || 'Non disponible'
			});
		};

		if (isOpen) {
			initClientInfo();
		}
	}, [isOpen]);

	const handleChange = (e) => {
		setFormData({
			...formData,
			[e.target.name]: e.target.value,
		});
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		setIsSubmitting(true);

		// Préparer les données avec les informations client
		const dataToSend = {
			...formData,
			userAgent: clientInfo.userAgent,
			ipAddress: clientInfo.ipAddress
		};

		try {
			const response = await fetch(`${env.API_URL}/contact`, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
				},
				body: JSON.stringify(dataToSend),
			});

			const result = await response.json();

			if (result.success) {
				setSubmitStatus('success');
				setFormData({
					nom: '',
					prenom: '',
					societe: '',
					telephone: '',
					email: '',
					message: '',
				});
				setTimeout(() => {
					onClose();
					setSubmitStatus(null);
				}, 2000);
			} else {
				setSubmitStatus('error');
			}
		} catch (error) {
			console.error("Erreur lors de l'envoi:", error);
			setSubmitStatus('error');
		} finally {
			setIsSubmitting(false);
		}
	};

	if (!isOpen) return null;

	return (
		<div className="contact-modal-overlay" onClick={onClose}>
			<div className="contact-modal" onClick={(e) => e.stopPropagation()}>
				<div className="contact-modal-header">
					<h2 className="contact-modal-title">Contact Us</h2>
					<button className="contact-close-button" onClick={onClose}>
						<svg width="24" height="24" viewBox="0 0 24 24" fill="none">
							<path
								d="M18 6L6 18M6 6L18 18"
								stroke="currentColor"
								strokeWidth="2"
								strokeLinecap="round"
							/>
						</svg>
					</button>
				</div>

				<form className="contact-form" onSubmit={handleSubmit}>
					<div className="contact-form-row">
						<div className="contact-form-group">
							<label className="contact-form-label" htmlFor="prenom">
								First Name *
							</label>
							<input
								className="contact-form-input"
								type="text"
								id="prenom"
								name="prenom"
								value={formData.prenom}
								onChange={handleChange}
								required
							/>
						</div>
						<div className="contact-form-group">
							<label className="contact-form-label" htmlFor="nom">
								Last Name *
							</label>
							<input
								className="contact-form-input"
								type="text"
								id="nom"
								name="nom"
								value={formData.nom}
								onChange={handleChange}
								required
							/>
						</div>
					</div>

					<div className="contact-form-group">
						<label className="contact-form-label" htmlFor="societe">
							Company
						</label>
						<input
							className="contact-form-input"
							type="text"
							id="societe"
							name="societe"
							value={formData.societe}
							onChange={handleChange}
						/>
					</div>

					<div className="contact-form-row">
						<div className="contact-form-group">
							<label className="contact-form-label" htmlFor="email">
								Email *
							</label>
							<input
								className="contact-form-input"
								type="email"
								id="email"
								name="email"
								value={formData.email}
								onChange={handleChange}
								required
							/>
						</div>
						<div className="contact-form-group">
							<label className="contact-form-label" htmlFor="telephone">
								Phone
							</label>
							<input
								className="contact-form-input"
								type="tel"
								id="telephone"
								name="telephone"
								value={formData.telephone}
								onChange={handleChange}
							/>
						</div>
					</div>

					<div className="contact-form-group">
						<label className="contact-form-label" htmlFor="message">
							Message *
						</label>
						<textarea
							className="contact-form-textarea"
							id="message"
							name="message"
							value={formData.message}
							onChange={handleChange}
							required
							rows="5"
						/>
					</div>

					<div className="contact-form-actions">
						<button
							type="button"
							onClick={onClose}
							className="contact-button-secondary"
						>
							Cancel
						</button>
						<button
							type="submit"
							disabled={isSubmitting}
							className="contact-button-primary"
						>
							{isSubmitting ? 'Sending...' : 'Send'}
						</button>
					</div>

					{submitStatus === 'success' && (
						<div className="contact-success-message">
							Message sent successfully!
						</div>
					)}

					{submitStatus === 'error' && (
						<div className="contact-error-message">
							Error sending message. Please try again.
						</div>
					)}
				</form>
			</div>
		</div>
	);
};

export default ContactForm;
